import type { HttpAdapter } from "../../core/adapters/axios.adapter";
import { type TokenDO } from "../models/tokenDO.models";

export class TokenDataService {
    constructor(private httpAdapter: HttpAdapter) { }

    async getTokenData(tokenSlug: string): Promise<TokenDO[]> {
        try {
            const url = `token/${tokenSlug}/data`;
            const response = await this.httpAdapter.get<TokenDO[]>(url);
            if (response.status < 200 || response.status > 300) { throw new Error('Failed to fetch token data') }

            return response.data;
        } catch (error) {
            console.error(error);
            return [];
        }
    }
}
